import $ from 'jquery';
import _ from 'underscore';
import Sortable from 'sortablejs';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Svg_Icon from 'root/module/svg_icon';
import Lang from 'root/module/widget_translation';
import View from 'view/base';

export default View.extend({
    tagName: 'form',
    className: 'setting-content',

    tab_selected: '#form', // #form #success
    show_all: true,

    events: {
        'click .update-click'               : 'onUpdateSettings',
        'keyup .update-keyup'               : 'onUpdateSettings',
        'input .update-input'               : 'onUpdateSettings',
        'click .radio-box'                  : 'onSelectRadioBox',
        'click .radio-box-capture-tool'     : 'onSelectCaptureTool',
        'click .radio-box-outro-icon'       : 'onSelectOutroIcon',
        'click input[name="outro_icon_0"]'  : 'onToggleOutroIcon',
        'click input[name="direct_to"]'     : 'onSelectDirectTo',
        'click .dropdown-rating-type li'    : 'onSelectRatingType',
        'click .dropdown-custom-field li'   : 'onSelectCustomFieldType',
        'click .field-add'                  : 'onAddField',
        'click .field-select > div'         : 'onSelectField',
        'click .field-delete'               : 'onDeleteField',
        'click .wildcard-input li'          : 'onInsertWildcard'
    },

    dom_handlers: {
        onUpdateSettings: function(e) {
            this.updateWidgetSettings();
        },

        onSelectRadioBox: function(e) {
            // stop parent view from receiving the event
            e.stopPropagation();

            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            if ($(e.currentTarget).hasClass('radio-box-multiple')) {
                $(e.currentTarget).toggleClass('selected');
            } else {
                $(e.currentTarget).parent().find('.radio-box').removeClass('selected');
                $(e.currentTarget).addClass('selected');
            }

            this.updateWidgetSettings();
        },

        onSelectCaptureTool: function(e) {
            this.$el.find('.capture-tool-text').text(this.getCaptureToolText());
            this.disableFlowOptions();
        },

        onSelectDirectTo: function(e) {
            this.widget.set('direct_to_' + this.model.get('widget_type'), $(e.currentTarget).val());
            this.$el.find('.flow-text').text(this.getFlowText());
        },

        onSelectOutroIcon: function(e) {
            this.$el.find('input[name="outro_icon_0"]').prop('checked', false);
        },

        onAddField: function(e) {
            this.$el.find('.field-select').toggle();
        },

        onSelectField: function(e) {
            var field_name = $(e.currentTarget).data('val');

            $(e.currentTarget).addClass('disabled');

            this.$el.find('.layout-box[data-val="' + field_name + '"]')
                .removeClass('layout-box-hidden')
                .addClass('layout-box-open');

            if (field_name === 'rating_type') {
                // select the first rating type
                this.$el.find('.dropdown-rating-type li:first').click();
            }

            this.updateWidgetSettings();
        },

        onDeleteField: function(e) {
            var layout_box = $(e.currentTarget).parents('.layout-box');
            var field_name = layout_box.data('val');

            layout_box.addClass('layout-box-hidden');
            this.$el.find('.field-select > div[data-val="' + field_name + '"]').removeClass('disabled');

            this.updateWidgetSettings();
        },

        onToggleOutroIcon: function(e) {
            var use_icon = !$(e.currentTarget).prop('checked');

            if (use_icon) {
                this.$el.find('.radio-box-outro-icon:first').addClass('selected');
            } else {
                this.$el.find('.radio-box-outro-icon').removeClass('selected');
            }

            this.updateWidgetSettings();
        },

        onSelectRatingType: function(e) {
            $(e.currentTarget).siblings().removeClass('selected');
            $(e.currentTarget).addClass('selected');

            this.updateWidgetSettings();

            this.$el.find('.dropdown-rating-type > button').text(this.getRatingText());
        },

        onSelectCustomFieldType: function(e) {
            $(e.currentTarget).siblings().removeClass('selected');
            $(e.currentTarget).addClass('selected');

            this.updateWidgetSettings();

            this.$el.find('.dropdown-custom-field > button').text(this.getCustomFieldText());
        },

        onInsertWildcard: function(e) {
            var wildcard = $(e.currentTarget).data('val');

            if (!wildcard) {
                return;
            }

            wildcard = '%%' + wildcard + '%%';

            var input = $(e.currentTarget).parents('.wildcard-input').find('input[type="text"],textarea');
            var start = input.get(0).selectionStart;
            var end = input.get(0).selectionEnd;

            var value = input.val().split('');
            value.splice(start, end - start, wildcard);

            input.val(value.join('')).trigger('keyup');
        },

        onDocumentClick: function(e) {
            var clicked_element = $(e.target);

            if (!clicked_element.hasClass('field-add')) {
                this.$el.find('.field-select').hide();
            }
        }
    },

    event_handlers: {
        onChangeLanguage: function() {
            Lang.setLang(this.widget.get('language'));

            this.$el.find('input[name="name_field_placeholder"]').attr('placeholder', Lang.get('your_name', true));
            this.$el.find('input[name="email_field_placeholder"]').attr('placeholder', Lang.get('your_email_address', true));
            this.$el.find('input[name="title_field_placeholder"]').attr('placeholder', Lang.get('feedback_title', true));
            this.$el.find('input[name="comment_field_placeholder"]').attr('placeholder', Lang.get('leave_us_your_comment', true));
            this.$el.find('input[name="category_field_placeholder"]').attr('placeholder', Lang.get('select_a_category', true));
            this.$el.find('input[name="priority_field_placeholder"]').attr('placeholder', Lang.get('select_a_priority', true));
            this.$el.find('input[name="assignee_field_placeholder"]').attr('placeholder', Lang.get('assign_to', true));
            this.$el.find('input[name="send_button_text"]').attr('placeholder', Lang.get('send', true));

            this.renderFieldCustomText();
        }
    },

    updateWidgetSettings: function() {
        var widget_settings = this.getSettings();
        this.model.set(widget_settings);
    },

    getSettings: function() {
        var form_data = Form.getData(this.$el);

        var field_order = [];
        var outro_icon = this.$el.find('.radio-box-outro-icon.selected').data('val') || 0;

        this.$el.find('.sortable-container .layout-box').each(function() {
            field_order.push($(this).data('val'));
        });

        var rating_enabled = !this.$el.find('.layout-box[data-val="rating_type"]').hasClass('layout-box-hidden');
        var custom_field_enabled = !this.$el.find('.layout-box[data-val="custom_field_1"]').hasClass('layout-box-hidden');

        // TODO:
        // next gen: header,
        // header_text: logo
        return {
            field_order                : field_order.join(','),
            allow_screenshot           : this.$el.find('.radio-box-capture-tool[data-val="screenshot"]').hasClass('selected'),
            allow_video                : this.$el.find('.radio-box-capture-tool[data-val="video"]').hasClass('selected'),
            allow_attachment           : this.$el.find('.radio-box-capture-tool[data-val="attachment"]').hasClass('selected'),
            rating_help_message        : form_data.rating_help_message || '',
            rating_type                : rating_enabled ? this.$el.find('.dropdown-rating-type li.selected').data('val') || '' : '',
            custom_field_1_type        : custom_field_enabled ? this.$el.find('.dropdown-custom-field li.selected').data('val') || '' : '',
            name_field                 : !this.$el.find('.layout-box[data-val="name"]').hasClass('layout-box-hidden'),
            email_field                : !this.$el.find('.layout-box[data-val="email"]').hasClass('layout-box-hidden'),
            title_field                : !this.$el.find('.layout-box[data-val="title"]').hasClass('layout-box-hidden'),
            comment_field              : !this.$el.find('.layout-box[data-val="comment"]').hasClass('layout-box-hidden'),
            display_category           : !this.$el.find('.layout-box[data-val="category"]').hasClass('layout-box-hidden'),
            display_priority           : !this.$el.find('.layout-box[data-val="priority"]').hasClass('layout-box-hidden'),
            display_assignee           : !this.$el.find('.layout-box[data-val="assignee"]').hasClass('layout-box-hidden'),
            rating_mandatory           : this.$el.find('.layout-box[data-val="rating_type"] .field-required').prop('checked'),
            name_field_mandatory       : this.$el.find('.layout-box[data-val="name"] .field-required').prop('checked'),
            email_field_mandatory      : this.$el.find('.layout-box[data-val="email"] .field-required').prop('checked'),
            title_field_mandatory      : this.$el.find('.layout-box[data-val="title"] .field-required').prop('checked'),
            comment_field_mandatory    : this.$el.find('.layout-box[data-val="comment"] .field-required').prop('checked'),
            category_field_mandatory   : this.$el.find('.layout-box[data-val="category"] .field-required').prop('checked'),
            priority_field_mandatory   : this.$el.find('.layout-box[data-val="priority"] .field-required').prop('checked'),
            assignee_field_mandatory   : this.$el.find('.layout-box[data-val="assignee"] .field-required').prop('checked'),
            custom_field_1_mandatory   : this.$el.find('.layout-box[data-val="custom_field_1"] .field-required').prop('checked'),
            custom_field_1_label       : form_data.custom_field_1_label      || '',
            name_field_placeholder     : form_data.name_field_placeholder    || '',
            email_field_placeholder    : form_data.email_field_placeholder   || '',
            title_field_placeholder    : form_data.title_field_placeholder   || '',
            comment_field_placeholder  : form_data.comment_field_placeholder || '',
            category_field_placeholder : form_data.category_field_placeholder || '',
            priority_field_placeholder : form_data.priority_field_placeholder || '',
            assignee_field_placeholder : form_data.assignee_field_placeholder || '',
            send_button_text           : form_data.send_button_text          || '',
            outro_icon                 : outro_icon,
            outro_headline             : form_data.outro_headline,
            outro_paragraph            : form_data.outro_paragraph
        };
    },

    initialize: function(options) {
        this.widget = options.widget;
        this.tab_selected = '#form';

        Lang.setLang(this.widget.get('language'));

        this.listenTo(this.widget, 'change:language', this.event_handlers.onChangeLanguage);
        this.listenTo(this.widget, 'change:header_text',               this.renderFieldCustomText);

        this.listenTo(this.model, 'change:rating_type',                this.renderFieldCustomText);
        this.listenTo(this.model, 'change:name_field_placeholder',     this.renderFieldCustomText);
        this.listenTo(this.model, 'change:email_field_placeholder',    this.renderFieldCustomText);
        this.listenTo(this.model, 'change:title_field_placeholder',    this.renderFieldCustomText);
        this.listenTo(this.model, 'change:comment_field_placeholder',  this.renderFieldCustomText);
        this.listenTo(this.model, 'change:category_field_placeholder', this.renderFieldCustomText);
        this.listenTo(this.model, 'change:priority_field_placeholder', this.renderFieldCustomText);
        this.listenTo(this.model, 'change:assignee_field_placeholder', this.renderFieldCustomText);
        this.listenTo(this.model, 'change:rating_help_message',        this.renderFieldCustomText);
        this.listenTo(this.model, 'change:custom_field_1_type',        this.renderFieldCustomText);
        this.listenTo(this.model, 'change:send_button_text',           this.renderFieldCustomText);

        $(document).on('click.widget_field_list', this.dom_handlers.onDocumentClick.bind(this));
        this.on('remove', () => {
            $(document).off('click.widget_field_list');
        });
    },

    show: function() {
        this.$el.addClass('open');
    },

    hide: function() {
        this.$el.removeClass('open');
    },

    disableFlowOptions: function() {
        var settings = this.getSettings();

        this.$el.find('input[name="direct_to"][value="screenshot"]').prop('disabled', !settings.allow_screenshot);
        this.$el.find('input[name="direct_to"][value="video"]').prop('disabled', !settings.allow_video);
    },

    getCaptureToolText: function() {
        if (!this.model.get('allow_screenshot') && !this.model.get('allow_video') && !this.model.get('allow_attachment')) {
            return '';
        }

        var text = '';

        if (this.model.get('allow_screenshot') && this.model.get('allow_video')) {
            text = 'Reporter can take screenshots OR a screen recording';
        } else if (this.model.get('allow_screenshot')) {
            text = 'Reporter can take screenshots';
        } else if (this.model.get('allow_video')) {
            text = 'Reporter can take a screen recording';
        }

        if (this.model.get('allow_attachment')) {
            if (text) {
                text += ', and attach a file';
            } else {
                text = 'Reporter can attach a file';
            }
        }

        return text;
    },

    getFlowText: function() {
        if (this.widget.isNextGen()) {
            switch (this.widget.get('direct_to_' + this.model.get('widget_type'))) {
                case 'form':
                    return 'User can click the Screenshot button to start annotating on the screen';
                case 'screenshot':
                    return 'Screenshot tool will start with the Feedback form together';
            }

            return '';
        } else {
            switch (this.widget.get('direct_to_' + this.model.get('widget_type'))) {
                case 'form':
                    return 'Reporter will start with the form';
                case 'screenshot':
                    return 'Reporter will start with a screenshot';
                case 'video':
                    return 'Reporter will start with a screen recording';
            }

            return 'Reporter will start from the form';
        }
    },

    getRatingText: function() {
        switch (this.model.get('rating_type')) {
            case 'star':
                return 'Stars';
            case 'emoji':
                return 'Faces';
            case 'heart':
                return 'Hearts';
            case 'number':
                return 'Numbers';
            case 'thumb':
                return 'Thumbs';
        }

        return 'Select...';
    },

    getCustomFieldText: function() {
        switch (this.model.get('custom_field_1_type')) {
            case 'checkbox':
                return 'Checkbox';
            case 'disclaimer':
                return 'Disclaimer Text';
            case 'short_answer':
                return 'Short Answer Question';
            case 'long_answer':
                return 'Long Answer Question';
        }

        return 'Select...';
    },

    getFieldCustomText: function(field_name) {
        switch (field_name) {
            case 'header_text':
                return this.widget.get('header_text') || Lang.get('welcome_message', true);
            case 'name':
                return this.model.get('name_field_placeholder') || Lang.get('your_name');
            case 'email':
                return this.model.get('email_field_placeholder') || Lang.get('your_email_address');
            case 'category':
                return this.model.get('category_field_placeholder') || Lang.get('select_a_category', true);
            case 'priority':
                return this.model.get('priority_field_placeholder') || Lang.get('select_a_priority', true);
            case 'assignee':
                return this.model.get('assignee_field_placeholder') || Lang.get('assign_to', true);
            case 'title':
                return this.model.get('title_field_placeholder') || Lang.get('feedback_title', true);
            case 'comment':
                return this.model.get('comment_field_placeholder') || Lang.get('leave_us_your_comment', true);
            case 'custom_field_1':
                return this.getCustomFieldText();
            case 'rating_help_message':
                return this.model.get('rating_help_message');
            case 'rating_type':
                return this.getRatingText();
            default:
                return '';
        }
    },

    getLayoutBox: function(value, heading, turned_on, is_required, has_toggle, is_locked) {
        var uid_required             = _.uniqueId(this.cid);
/*
        var uid_bug                  = _.uniqueId(this.cid);
        var uid_general              = _.uniqueId(this.cid);
        var uid_feature_request      = _.uniqueId(this.cid);
        var uid_type_empty           = _.uniqueId(this.cid);
        var uid_type_bug             = _.uniqueId(this.cid);
        var uid_type_general         = _.uniqueId(this.cid);
        var uid_type_feature_request = _.uniqueId(this.cid);
*/

        var html =
        '<div class="layout-box' + (is_locked ? ' layout-box-locked' : '') + (turned_on ? '' : ' layout-box-hidden') + '" data-val="' + value + '">' +
            '<div class="layout-box-heading layout-box-heading-indented layout-box-heading-field">' +
                '<div class="field-icon" data-val="' + value + '"></div>' +
                (is_locked ? '' :
                '<div class="drag-handle"><i class="fas fa-grip-dots-vertical"></i></div>') +
                (has_toggle ?
                '<button type="button" class="field-delete small square round tooltip" data-title="Delete"><i class="fa-solid fa-trash"></i></button>' : '') +
                '<div class="ellipsis">' +
                    '<div class="field-title">' + heading + '</div>' +
                    '<div class="field-custom-text">' + this.getFieldCustomText(value) + '</div>' +
                '</div>' +
            '</div>' +
            '<div class="layout-box-content layout-box-content-single">' +
                '<div class="flex-between margin-bottom-12">' +
                    '<div class="font-weight-semibold">' + heading + '</div>' +
                    '<div>' +
                        (has_toggle ?
                        '<input type="checkbox" class="update-click field-required" id="' + uid_required + '"' + (is_required ? ' checked' : '') + '>' +
                        '<label for="' + uid_required + '">Required</label>' : '') +
                    '</div>' +
                '</div>' +

                '<div>' +
                    (value === 'header_text' ?
                    '<button type="button" class="logo-upload small tertiary fluid square text-align-left flex-between">' +
                        '<span><i class="fa-solid fa-upload"></i> Upload logo</span>' +
                        '<div class="logo-preview flex-c"' + (this.widget.get('logo') ? '' : ' style="display:none;"') + '>' +
                            '<img height="16" src="' + this.widget.escape('logo') +  '">' +
                            '<a href="#" class="logo-delete margin-left-12 text-info tooltip" data-title="Remove logo"><i class="fa-solid fa-circle-xmark"></i></a>' +
                        '</div>' +
                    '</button>' +
                    '<div class="text-info text-small text-align-right margin-top-4">Image height: ' + (this.widget.isNextGen() ? '24px' : '36px') + '</div>' +
                    '<div class="wildcard-input">' +
                        '<input type="text" class="update-keyup solid compact" maxlength="100" name="header_text" placeholder="' + Lang.get('welcome_message', true) + '">' +
                        '<div class="button-dropdown button-dropdown-large">' +
                            '<button class="tiny square round text-info tooltip" data-title="Insert placeholder"><i class="fa-solid fa-brackets-curly"></i></button>' +
                            '<div>' +
                                '<ul class="dropdown">' +
                                    '<li data-val="email">email</li>' +
                                    '<li data-val="name">name</li>' +
                                    '<li class="separator"></li>' +
                                    '<li class="dropdown-title margin-left-0">Custom Properties</li>' +
                                    Cache.user_properties.map((property) => {
                                        return '<li data-val="' + Util.htmlEntities(property) + '">' + Util.htmlEntities(property) + '</li>';
                                    }).join('') +
                                    (Cache.user_properties.length === 0 ? '<li class="disabled">No custom properties identified</li>' : '') +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                    '</div>' : '') +

                    (value === 'name' ?
                    '<input type="text" class="update-keyup solid compact" maxlength="100" name="name_field_placeholder" placeholder="' + Lang.get('your_name', true) + '">' +
                    '<div class="margin-top-8">Name is pre-filled ' + (this.widget.isNextGen() ? 'and hidden ' : '') + 'for <a class="primary" href="https://support.userback.io/en/articles/9416861-user-database-segments" target="help" rel="noopener">Identified Users <i class="fa-solid fa-square-arrow-up-right"></i></a></div>' : '') +

                    (value === 'email' ?
                    '<input type="text" class="update-keyup solid compact" maxlength="100" name="email_field_placeholder" placeholder="' + Lang.get('your_email_address', true) + '">' +
                    '<div class="margin-top-8">Email is pre-filled ' + (this.widget.isNextGen() ? 'and hidden ' : '') + 'for <a class="primary" href="https://support.userback.io/en/articles/9416861-user-database-segments" target="help" rel="noopener">Identified Users <i class="fa-solid fa-square-arrow-up-right"></i></a></div>': '') +

                    (value === 'title' ?
                    '<input type="text" class="update-keyup solid compact" maxlength="100" name="title_field_placeholder" placeholder="' + Lang.get('feedback_title', true) + '">' : '') +

                    (value === 'comment' ?
                    '<input type="text" class="update-keyup solid compact" maxlength="100" name="comment_field_placeholder" placeholder="' + Lang.get('leave_us_your_comment', true) + '">' : '') +

                    (value === 'category' ?
                    '<input type="text" class="update-keyup solid compact" maxlength="100" name="category_field_placeholder" placeholder="' + Lang.get('select_a_category', true) + '">' : '') +

                    (value === 'priority' ?
                    '<input type="text" class="update-keyup solid compact" maxlength="100" name="priority_field_placeholder" placeholder="' + Lang.get('select_a_priority', true) + '">' : '') +

                    (value === 'assignee' ?
                    '<input type="text" class="update-keyup solid compact" maxlength="100" name="assignee_field_placeholder" placeholder="' + Lang.get('assign_to', true) + '">' : '') +

                    (value === 'rating_help_message' ?
                    '<input type="text" class="update-keyup solid compact margin-bottom-0" maxlength="100" name="rating_help_message" placeholder="e.g. How would you rate your experience?">' +
                    '<div class="maxlength-help"></div>': '') +

                    (value === 'send_button_text' ?
                    '<input type="text" class="update-keyup solid compact" maxlength="100" name="send_button_text" placeholder="' + Lang.get('send') + '">' : '') +

                    (value === 'rating_type' ?
                    '<div class="button-dropdown button-dropdown-full dropdown-rating-type">' +
                        '<button type="button" class="dropdown-select">' + this.getRatingText() + '</button>' +
                        '<div>' +
                            '<ul class="dropdown dropdown-select">' +
                                '<li data-val="star"'   + (this.model.get('rating_type') === 'star'   ? ' class="selected"' : '')  + '>Stars</li>' +
                                '<li data-val="heart"'  + (this.model.get('rating_type') === 'heart'  ? ' class="selected"' : '') + '>Hearts</li>' +
                                '<li data-val="emoji"'  + (this.model.get('rating_type') === 'emoji'  ? ' class="selected"' : '') + '>Faces</li>' +
                                '<li data-val="number"' + (this.model.get('rating_type') === 'number' ? ' class="selected"' : '') + '>Numbers</li>' +
                                '<li data-val="thumb"'  + (this.model.get('rating_type') === 'thumb'  ? ' class="selected"' : '') + '>Thumbs</li>' +
                            '</ul>' +
                        '</div>' +
                    '</div>' : '') +

                    (value === 'custom_field_1' ?
                    '<div class="button-dropdown button-dropdown-full dropdown-custom-field">' +
                        '<button type="button" class="dropdown-select">' + this.getCustomFieldText() + '</button>' +
                        '<div>' +
                            '<ul class="dropdown dropdown-select">' +
                                '<li data-val="checkbox"'     + (this.model.get('custom_field_1_type') === 'checkbox'     ? ' class="selected"' : '') + '>Checkbox</li>' +
                                '<li data-val="disclaimer"'   + (this.model.get('custom_field_1_type') === 'disclaimer'   ? ' class="selected"' : '') + '>Disclaimer Text</li>' +
                                '<li data-val="short_answer"' + (this.model.get('custom_field_1_type') === 'short_answer' ? ' class="selected"' : '') + '>Short Answer Question</li>' +
                                '<li data-val="long_answer"'  + (this.model.get('custom_field_1_type') === 'long_answer'  ? ' class="selected"' : '') + '>Long Answer Question</li>' +
                            '</ul>' +
                        '</div>' +
                    '</div>' +
                    '<textarea name="custom_field_1_label" class="update-keyup solid compact margin-top-8 margin-bottom-4" rows="4" maxlength="1000" placeholder="I agree to [terms and conditions](https://www.example.com)."></textarea>' +
                    '<div class="flex-between margin-bottom-12">' +
                        '<div class="text-info text-medium">You can use markdown syntax to add link</div>' +
                        '<div class="maxlength-help"></div>' +
                    '</div>' : '') +
                '</div>' +
            '</div>' +
        '</div>';

        return html;
    },

    sortable: function() {
        new Sortable(this.$el.find('.sortable-container').get(0), {
            ghostClass: 'drag-placeholder',
            handle: '.drag-handle',
            animation: 200,
            onSort: () => {
                this.updateWidgetSettings();
            }
        });
    },

    renderFieldCustomText: function() {
        var fields = ['header_text', 'email', 'name', 'title', 'comment', 'category', 'priority', 'assignee', 'custom_field_1', 'rating_help_message', 'rating_type'];

        fields.forEach((field_name) => {
            var custom_text = this.getFieldCustomText(field_name);
            this.$el.find('.layout-box[data-val="' + field_name + '"] .field-custom-text').text(custom_text);
        });
    },

    goToTab: function(tab) {
        this.tab_selected = tab;

        this.$el.find('.tab-menu > a').removeClass('active');
        this.$el.find('.tab-menu > div').removeClass('active');

        this.$el.find('.tab-menu > a[href="' + tab + '"]').addClass('active');
        this.$el.find('.tab-content > div[data-val="' + tab + '"]').addClass('active');
    },

    render: function() {
        var uid_no_icon                     = _.uniqueId(this.cid);
        var uid_direct_to_form              = _.uniqueId(this.cid);
        var uid_direct_to_screenshot        = _.uniqueId(this.cid);
        var uid_direct_to_video             = _.uniqueId(this.cid);

        var is_rating_on         = this.model.get('rating_type') !== '';
        var is_email_on          = this.model.get('email_field');
        var is_name_on           = this.model.get('name_field');
        var is_title_on          = this.model.get('title_field');
        var is_comment_on        = this.model.get('comment_field');
        var is_category_on       = this.model.get('display_category');
        var is_priority_on       = this.model.get('display_priority');
        var is_assignee_on       = this.model.get('display_assignee');
        var is_custom_field_1_on = this.model.get('custom_field_1_type') !== '';

        var field_items            = {};
        field_items.name           = this.getLayoutBox('name',           'Name',         is_name_on,           this.model.get('name_field_mandatory'),     true,  false);
        field_items.email          = this.getLayoutBox('email',          'Email',        is_email_on,          this.model.get('email_field_mandatory'),    true,  false);
        field_items.category       = this.getLayoutBox('category',       'Category',     is_category_on,       this.model.get('category_field_mandatory'), true,  false);
        field_items.priority       = this.getLayoutBox('priority',       'Priority',     is_priority_on,       this.model.get('priority_field_mandatory'), true,  false);
        field_items.assignee       = this.getLayoutBox('assignee',       'Assignee',     is_assignee_on,       this.model.get('assignee_field_mandatory'), true,  false);
        field_items.title          = this.getLayoutBox('title',          'Title',        is_title_on,          this.model.get('title_field_mandatory'),    true,  false);
        field_items.comment        = this.getLayoutBox('comment',        'Description',  is_comment_on,        this.model.get('comment_field_mandatory'),  !this.widget.isNextGen(), false);
        field_items.custom_field_1 = this.getLayoutBox('custom_field_1', 'Custom Field', is_custom_field_1_on, this.model.get('custom_field_1_mandatory'), true,  false);

        var project = Cache.project.get(this.widget.get('project_id'));

        var item_order = this.model.get('field_order').split(',');
        var field_item_options = '';

        _.each(field_items, function(item, item_type) {
            if (item_order.indexOf(item_type) === -1) {
                field_item_options += item;
            }
        });

        // missing fields from the saved field_order
        item_order.forEach(function(item_type) {
            if (typeof field_items[item_type]) {
                field_item_options += (field_items[item_type] || '');
            }
        });

        var content =
        '<div class="tab">' +
            '<div class="tab-menu tab-menu-child">' +
                '<a href="#form">Fields</a>' +
                '<a href="#success">Success</a>' +
            '</div>' +
            '<div class="tab-content">' +
                '<div data-val="#form">' +
                    (this.widget.isNextGen() ?
                    this.getLayoutBox('header_text',         'Header', true, false, false, true) : '') +

                    (!this.widget.isNextGen() ?
                    this.getLayoutBox('rating_help_message', 'Intro', true, false, false, true) : '') +

                    this.getLayoutBox('rating_type',         'Rating', is_rating_on, this.model.get('rating_mandatory'), true, true) +

                    '<div class="sortable-container">' + field_item_options + '</div>' +

                    '<div class="divider-16"></div>' +
                    '<div class="position-relative">' +
                        '<button type="button" class="field-add tertiary small min">Add</button>' +
                        '<div class="field-select">' +
                            '<div' + (is_rating_on         ? ' class="disabled"' : '') + ' data-val="rating_type">Rating</div>' +
                            '<div' + (is_email_on          ? ' class="disabled"' : '') + ' data-val="email">Email</div>' +
                            '<div' + (is_name_on           ? ' class="disabled"' : '') + ' data-val="name">Name</div>' +
                            '<div' + (is_title_on          ? ' class="disabled"' : '') + ' data-val="title">Title</div>' +
                            (this.widget.isNextGen() ? '' :
                            '<div' + (is_comment_on        ? ' class="disabled"' : '') + ' data-val="comment">Description</div>') +
                            '<div' + (is_category_on       ? ' class="disabled"' : '') + ' data-val="category">Category</div>' +
                            '<div' + (is_priority_on       ? ' class="disabled"' : '') + ' data-val="priority">Priority</div>' +
                            '<div' + (is_assignee_on       ? ' class="disabled"' : '') + ' data-val="assignee">Assignee</div>' +
                            '<div' + (is_custom_field_1_on ? ' class="disabled"' : '') + ' data-val="custom_field_1">Custom Field</div>' +
                        '</div>' +
                    '</div>' +

                    '<hr class="medium">' +

                    '<div class="setting-title">Tools</div>' +
                    '<div>Choose the tools reporters can use</div>' +
                    '<div class="divider-12"></div>' +
                    '<div class="radio-box-select radio-box-select-3">' +
                        '<div class="radio-box radio-box-multiple radio-box-capture-tool" data-val="screenshot"' + (this.widget.isNextGen() ? 'data-nextgen="true"' : '') + '></div>' +
                        '<div class="radio-box radio-box-multiple radio-box-capture-tool" data-val="video"></div>' +
                        '<div class="radio-box radio-box-multiple radio-box-capture-tool" data-val="attachment"></div>' +
                    '</div>' +
                    '<div class="capture-tool-text text-info text-medium margin-top-12">' + this.getCaptureToolText() + '</div>' +
                    '<div class="divider-12"></div>' +
                    '<div class="region-flow-options">' +
                        '<div class="divider-12"></div>' +
                        (this.widget.isNextGen() ?
                        '<div>Open screenshot tool by default</div>' +
                        '<div class="divider-12"></div>' +
                        '<input type="radio" name="direct_to" value="form" id="' + uid_direct_to_form + '"><label for="' + uid_direct_to_form + '">No</label>' +
                        '<input type="radio" name="direct_to" value="screenshot" id="' + uid_direct_to_screenshot + '"><label for="' + uid_direct_to_screenshot + '">Yes</label>' +
                        '<div class="flow-text text-info text-medium margin-top-12">' + this.getFlowText() + '</div>'

                        :

                        '<div>Set a capturing tool as the starting point</div>' +
                        '<div class="divider-12"></div>' +
                        '<input type="radio" name="direct_to" value="form" id="' + uid_direct_to_form + '"><label for="' + uid_direct_to_form + '">None</label>' +
                        '<input type="radio" name="direct_to" value="screenshot" id="' + uid_direct_to_screenshot + '"><label for="' + uid_direct_to_screenshot + '">Screenshot</label>' +
                        '<input type="radio" name="direct_to" value="video" id="' + uid_direct_to_video + '"><label for="' + uid_direct_to_video + '">Screen Recording</label>' +
                        '<div class="flow-text text-info text-medium margin-top-8">' + this.getFlowText() + '</div>') +
                    '</div>' +

                    '<hr class="medium">' +

                    '<div class="setting-title">Button</div>' +
                    '<div>Customize the button text</div>' +
                    '<div class="divider-12"></div>' +
                    '<div class="input-short">' +
                        '<input type="text" name="send_button_text" class="update-keyup solid compact" maxlength="24" placeholder="' + (this.model.get('send_button_text') || Lang.get('send')) + '">' +
                        '<div class="maxlength-help"></div>' +
                    '</div>' +
                '</div>' +
                '<div data-val="#success">' +
                    '<div class="setting-title">Style</div>' +
                    '<div class="setting-subtitle">Icon</div>' +
                    '<input type="checkbox" name="outro_icon_0" id="' + uid_no_icon + '"><label for="' + uid_no_icon + '">Do not use an icon</label>' +
                    '<div class="divider-12"></div>' +
                    '<div class="radio-box-select radio-box-select-6">' +
                        '<div class="radio-box radio-box-outro-icon" data-val="1">' + Svg_Icon.check_circle + '</div>' +
                        '<div class="radio-box radio-box-outro-icon" data-val="6"><span class="emoji">🥳</span></div>' +
                        '<div class="radio-box radio-box-outro-icon" data-val="7"><span class="emoji">👏</span></div>' +
                        '<div class="radio-box radio-box-outro-icon" data-val="8"><span class="emoji">👍</span></div>' +
                        '<div class="radio-box radio-box-outro-icon" data-val="9"><span class="emoji">✨</span></div>' +
                        '<div class="radio-box radio-box-outro-icon" data-val="10"><span class="emoji">🎉</span></div>' +
                    '</div>' +

                    '<hr class="medium">' +

                    '<div class="setting-title">Text</div>' +
                    '<div class="setting-subtitle">Heading</div>' +
                    '<div>' +
                        '<div class="wildcard-input">' +
                            '<input type="text" name="outro_headline" class="update-keyup solid compact" maxlength="120" placeholder="Thank you!">' +
                            '<div class="button-dropdown button-dropdown-large">' +
                                '<button class="tiny square round text-info tooltip" data-title="Insert placeholder"><i class="fa-solid fa-brackets-curly"></i></button>' +
                                '<div>' +
                                    '<ul class="dropdown">' +
                                        '<li data-val="email">email</li>' +
                                        '<li data-val="name">name</li>' +
                                        '<li class="separator"></li>' +
                                        '<li class="dropdown-title margin-left-0">Custom Properties</li>' +
                                        Cache.user_properties.map((property) => {
                                            return '<li data-val="' + Util.htmlEntities(property) + '">' + Util.htmlEntities(property) + '</li>';
                                        }).join('') +
                                        (Cache.user_properties.length === 0 ? '<li class="disabled">No custom properties identified</li>' : '') +
                                    '</ul>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                        '<div class="maxlength-help"></div>' +
                    '</div>' +
                    '<div class="divider-24"></div>' +
                    '<div class="setting-subtitle">Message</div>' +
                    '<div>' +
                        '<div class="wildcard-input">' +
                            '<textarea name="outro_paragraph" class="update-keyup solid compact" rows="4" maxlength="500" placeholder="You can visit our [website](https://www.example.com) for more information."></textarea>' +
                            '<div class="button-dropdown button-dropdown-large">' +
                                '<button class="tiny square round text-info tooltip" data-title="Insert placeholder"><i class="fa-solid fa-brackets-curly"></i></button>' +
                                '<div>' +
                                    '<ul class="dropdown">' +
                                        '<li data-val="email">email</li>' +
                                        '<li data-val="name">name</li>' +
                                        '<li class="separator"></li>' +
                                        '<li class="dropdown-title margin-left-0">Custom Properties</li>' +
                                        Cache.user_properties.map((property) => {
                                            return '<li data-val="' + Util.htmlEntities(property) + '">' + Util.htmlEntities(property) + '</li>';
                                        }).join('') +
                                        (Cache.user_properties.length === 0 ? '<li class="disabled">No custom properties identified</li>' : '') +
                                    '</ul>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                        '<div class="flex-between">' +
                            '<div class="text-info text-medium margin-top-4">You can use markdown syntax to add links</div>' +
                            '<div class="maxlength-help"></div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        this.$el.toggleClass('setting-content-float', this.widget.isNextGen());

        // tab
        this.goToTab(this.tab_selected);

        // Set Form Data
        Form.setData(this.$el, {
            direct_to                          : [this.widget.get('direct_to_' + this.model.get('widget_type'))],
            rating_help_message                : this.model.get('rating_help_message'),
            outro_headline                     : this.model.get('outro_headline'),
            outro_paragraph                    : this.model.get('outro_paragraph'),
            custom_field_1_label               : this.model.get('custom_field_1_label'),
            name_field_placeholder             : this.model.get('name_field_placeholder'),
            email_field_placeholder            : this.model.get('email_field_placeholder'),
            title_field_placeholder            : this.model.get('title_field_placeholder'),
            comment_field_placeholder          : this.model.get('comment_field_placeholder'),
            category_field_placeholder         : this.model.get('category_field_placeholder'),
            priority_field_placeholder         : this.model.get('priority_field_placeholder'),
            assignee_field_placeholder         : this.model.get('assignee_field_placeholder'),
            send_button_text                   : this.model.get('send_button_text')
        });

        // capture tools
        if (this.model.get('allow_screenshot')) {
            this.$el.find('.radio-box-capture-tool[data-val="screenshot"]').addClass('selected');
        }

        // attachment
        if (this.model.get('allow_attachment')) {
            this.$el.find('.radio-box-capture-tool[data-val="attachment"]').addClass('selected');
        }

        if (this.model.get('allow_video')) {
            this.$el.find('.radio-box-capture-tool[data-val="video"]').addClass('selected');
        }

        // Icon
        if (this.model.get('outro_icon') === 0) {
            this.$el.find('#' + uid_no_icon).prop('checked', true);
        } else {
            this.$el.find('.radio-box-outro-icon[data-val="' + this.model.get('outro_icon') + '"]').addClass('selected');
        }

        // flow options
        this.disableFlowOptions();

        this.sortable();

        return this;
    }
});